import { useDispatch, useSelector } from "react-redux";
import formatPhoneNumber from "../Helper/formatPhoneNumber";

import {
  Button,
  Grid,
  IconButton,
  InputBase,
  Tooltip,
} from "@mui/material";

import BackspaceIcon from '@mui/icons-material/Backspace';
import CallIcon from '@mui/icons-material/Call';
import './DialPad.css';
import { sendDTMF } from "../Store/SIP/call";

const DialPad = ({
  phoneNumber,
  setPhoneNumber,
  handleCall
}) => {
  const dispatch = useDispatch();

  const {
    sipAccount,
    CurrentState
  } = useSelector((state) => state.auth);

  const { isInCall } = useSelector((state) => state.call);

  const Key = ({ symbol }) => {
    return (
      <Grid
        item
        xs={4}
      >
        <Button
          variant="contained"
          className="dialpad-key"
          // disabled={CurrentState !== 'READY'}

          onClick={() => {
            if (isInCall) {
              dispatch(sendDTMF(symbol));
            }

            const formattedPhoneNumber = formatPhoneNumber(phoneNumber + symbol);
            setPhoneNumber(formattedPhoneNumber);
          }}
        >
          {symbol}
        </Button>
      </Grid>
    )
  }

  return (
    <div className="dialpad">
      <section className="dialpad-input">
        <InputBase 
          value={phoneNumber}
          type="tel"
          // temp disabled
          // inputProps={{ maxLength: 18 }}
          autoFocus
          disabled={CurrentState !== 'READY'}

          onChange={e => {
            const formattedPhoneNumber = formatPhoneNumber(e.target.value);
            setPhoneNumber(formattedPhoneNumber);
          }}

          onKeyDown={e => {
            if (e.key === 'Enter') {
              handleCall();
              e.preventDefault();
            }
          }}
        />

        <Tooltip
          title="Backspace"
          arrow
        >
          <IconButton
            disabled={CurrentState !== 'READY'}
            onClick={() => setPhoneNumber(phoneNumber.slice(0, -1))}
          >
            <BackspaceIcon />
          </IconButton>
        </Tooltip>
      </section>

      <section className="dialpad-keys">
        <Grid
          container
          columnSpacing={'14px'}
          spacing={2}
        >
          <Key symbol="1" />
          <Key symbol="2" />
          <Key symbol="3" />
          <Key symbol="4" />
          <Key symbol="5" />
          <Key symbol="6" />
          <Key symbol="7" />
          <Key symbol="8" />
          <Key symbol="9" />
          <Key symbol="*" />
          <Key symbol="0" />
          <Key symbol="#" />
          
          <Grid
            item
            xs={12}
          >
            <Button
              variant="contained"
              className="dialpad-key call-button"
              disabled={
                CurrentState !== "READY" ||
                !sipAccount ||
                phoneNumber.length < 4
              }
              onClick={() => handleCall()}
            >
              <CallIcon />
            </Button>
          </Grid>
        </Grid>
      </section>
    </div>
  );
};

export default DialPad;